import Button from '@/shared/components/Button/Button'
import DynamicForm from '@/shared/components/DynamicForm/DynamicForm'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from '@/features/auth/Forms/Register/Register.module.scss'
import { useRegisterFormConfig } from '@/features/auth/Forms/Register/useRegisterFormConfig'

function Register() {
  const [isDirty, setIsDirty] = useState(true)
  const { t } = useTranslation()
  const formConfig = useRegisterFormConfig()

  return (
    <div className={`${styles.registerContainer}`}>
      <h1 className={`title-bold-medium ${styles.registerHeader}`}>
        {t('AUTHORIZATION.REGISTER.TITLE.FIRST_PART')}
        <mark className="mark-orange">
          {t('AUTHORIZATION.REGISTER.TITLE.SECOND_PART')}
        </mark>
      </h1>

      <DynamicForm setIsDirty={setIsDirty} validationMode="onSubmit" {...formConfig} />
      <div className={`${styles.registerFormButtonContainer}`}>
        <Button
          form="register-form"
          onClick={() => {}}
          label={t('AUTHORIZATION.REGISTER.REGISTER')}
          variant="contained"
          color="primary"
          type="submit"
          disabled={isDirty}
          maxWidth
        />
      </div>
    </div>
  )
}

export default Register
